<template>
  <div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(judgement, index) in judgements"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="judgement"
            :icon="'mdi-gavel'"
            :header="local.caseFile.cards.judgement.header"
            :code-display-name="local.caseFile.cards.judgement.codeDisplayName"
            :code="judgement.code"
            :status=" judgement.judgementStatus"
            :status-display-name="local.caseFile.cards.judgement.statusDisplayName"
            :date="judgement.conclusiveDate"
            :date-display-name="local.caseFile.cards.judgement.dateDisplayName"
            :has-actions="showJudgmentActions"
            :court-name="judgement.courtName"
            :sub-circle-name="judgement.subCircleName"
            @card-click="viewAttachment(judgement)"
          >
            <template
              v-if="showNewRequest && !isMainRequestSecretariesApproved"
              slot="actions"
              slot-scope="{}"
            >
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon
                    large
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <naj-button
                        text
                        type="button"
                        size="small"
                        @click="viewVerdictObjection(judgement)"
                      >
                        {{ local.bankruptcy.bankruptcyFile.requests.verdictObjectionRequest.verdictObjection }}
                      </naj-button>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="judgements && judgements.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>
    <pdf-modal
      v-if="selectedFile"
      ref="pdfModal"
      :file-name="selectedFile.fileName"
      :share-point-id="selectedFile.spid"
      @modalClose="hideViewAttachmentModal"
    >
    </pdf-modal>

    <naj-confirmation
      :show-modal="showVerdictObjection"
      :max-width="771"
      :title="objectionRequestType.title"
      :show-close-btn="false"
      @cancel="() => {
        showVerdictObjection = false
        pledged = false;
      }"
    >
      <template slot="actions">
        <naj-button
          :disabled="!pledged"
          @click="openSubmitVerdictObjectionRequest()"
        >
          {{ local.common.saveAndSend }}
        </naj-button>
      </template>
      <template slot="message-content">
        <naj-input
          :type-id="formFieldType.checkbox"
          :value.sync="pledged"
          :label="objectionRequestType.shortExplanation"
        ></naj-input>
      </template>
    </naj-confirmation>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import BankruptcyCard from '../bankruptcy-card.vue';
import PdfModal from '@/components/shared/pdf-modal/index.vue';
const { mapActions, mapState } = createNamespacedHelpers('BankruptcyModule');
import { subRequestTypesEnum } from '@/modules/bankruptcy/helpers/enum';
import { procedureTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'JudgementsTab',
  components: {
    BankruptcyCard,
    PdfModal,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestInfo: {
      type: Object,
      required: true,
    },
    showNewRequest: {
      type: Boolean,
      required: false,
    },
    isMainRequestSecretariesApproved: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      procedureTypeEnum,
      loading: false,
      selectedFile: null,
      selectedJudgement: null,
      judgements: [],
      showVerdictObjection: false,
      pledged: false,
      subRequestTypesEnum,
      objectionRequestType: subRequestTypesEnum.objectionRequest,
      showJudgmentActions: true,
    };
  },
  computed: {
    isRequestOwner() {
      return this.requestInfo.isRequestOwner;
    },
    showObjectionRequest() {
      return this.showNewRequest && !this.userInfo.isBankruptcyTrustee;
    },
    ...mapState({ userInfo: state => state.currentUser }),
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getJudgementsByRequestObjectKey', 'canIssueSubRequest']),
    loadData() {
      this.loading = true;
      this.getJudgementsByRequestObjectKey(this.requestObjectKey)
        .then((res) => {
          this.judgements = res.data;
          if (this.userInfo.isOrganizationUser && this.userInfo.isBankruptcyTrustee && this.requestInfo.procedureTypeId != procedureTypeEnum.administrativeLiquidation)
            this.showJudgmentActions = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewAttachment(judgement) {
      if (judgement.spid) {
        this.selectedFile = judgement;
        this.$nextTick(() => {
          var modal = this.$refs.pdfModal;
          modal.showModal();
        });
      }
    },
    hideViewAttachmentModal() {
      this.selectedFile = null;
    },
    viewVerdictObjection(judgement) {
      const params = {
        objectKey: this.requestObjectKey,
        requestType: this.objectionRequestType.id,
        judgementId: judgement.id,
      };
      this.canIssueSubRequest(params)
        .then((res) => {
          if (res.data) {
            this.selectedJudgement = judgement;
            this.showVerdictObjection = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openSubmitVerdictObjectionRequest() {
      this.showVerdictObjection = false;
      this.$router.push({ path: `/bankruptcy/${this.requestObjectKey}/bankruptcy-file/VerdictObjectionRequest?judgementCode=${this.selectedJudgement.code}&isInternal=${true}` });
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
